import Vue from 'vue';

// hook which checks for a flag in session storage which enables devtool support. this allows us to use devtools on ad-hoc basis in
// non-development environments (where it's disabled by default).
if (sessionStorage.getItem('DEVTOOLS') === 'true')
{
  Vue.config.devtools = true;
}